<script>
import forminput from "@/router/views/formcomponet/forminput.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import obirimbelge from "@/models/obirimbelge";
import useVuelidate from "@vuelidate/core";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, obirimbelge],
  props: ["Id", "AddEdit"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
    };
  },
  components: {
    forminput, treeselect
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.FormData.Olusturanid = this.TokenPersonelId
    },
  },
  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("obirimbelge", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.obirimbelgeData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            } 
          });
        } else {
          this.Update("obirimbelge", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.obirimbelgeData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },
    Get() { },
    
    FileUpload(event) {
      var file = event.target.files[0];
      if (!file) return;

      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg" || uzanti == "docx" || uzanti == "xlsx" || uzanti == "pdf"  || uzanti == "tar" || uzanti == "zip") {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Tlp",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {
             
              this.FormData.Dosyayolu = res.Data.filename;
              this.$toast.success("Dosya yüklendi");
           
          } else {
            this.$toast.error("Dosya yüklenmedi!");
          }
        });
      }
      else {
        this.$toast.error("Hatalı Dosya Uzantısı!");
      }
    },
  },

  computed: {


  }
};
</script>
<template>
  <b-modal v-model="ModalOpen" id="obirimbelge" size="lg" :title="this.AddEdit == 'Edit'
    ? 'Kayıt Düzenle'
    : 'Yeni Kayıt Ekle'
    " title-class="font-18" hide-footer>
    <Form @submit.prevent="onSubmit" v-if="FormData">


      <div class="row">
         
        <forminput class="col-lg-6" :FormDataType="FormDataType.Baslik" :Value="FormData.Baslik" :v="v$.FormData.Baslik"
          @input="FormData.Baslik = $event.target.value" />

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Birimid.FieldTitle"
          :key="FormData.Birimid">
          <treeselect :multiple="false" :options="FormDataType.Birimid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Birimid" />
          <treeselect-value :value="FormData.Birimid" />
        </b-form-group>


  <b-form-group class="col-md-6" label="Belge">
                      <input class="form-control upload-input col-md-12 mt-3" ref="file" type="file"
                        @change="FileUpload($event)" id="FormData.IcerikDosya"
                        accept=".jpg, .jpeg, .png, .12, .pdf, .docx, .tar, .zip" />
                    </b-form-group>


      </div>
      <button class="btn btn-primary" type="submit">
        Kaydet
      </button>
    </Form>
  </b-modal>
</template>
